import React, { useState, useEffect } from 'react';
import { Document } from '../models/document';
import { AssayCalculator } from '../models/assay-calculator';
import { CalculatorStandard } from '../models/Calculators/calculator-standard';
import { CalculatorStandardComponent } from '../models/Calculators/calculator-standard-component';
import AgilentRawDataFileComponent from './AgilentRawDataFileComponent';
import CalculatorStandards from './CalculatorStandards';
import CalculatorComponents from './CalculatorComponents';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';
import { CrudFunctions } from '../utilities/crud-functions';
import { AgilentRawDataFile } from '../models/Calculators/agilent-raw-data-file';
import { MasterAssayCalculatorData } from '../models/Calculators/master-assay-calculator-data';
import { AssayRawData } from '../models/assay-raw-data';
import { LookupItem } from '../models/lookup-item';
import DataTemplates from '../templates/data-templates';
import DmaFooter from './DmaFooter';

import DataGrid, {
    Column,
    Selection,
    Paging,
    Editing,
    Toolbar,
    Item as ToolbarItem
} from 'devextreme-react/data-grid';

import { NumberBox } from 'devextreme-react/number-box';
import { TextBox } from 'devextreme-react/text-box';
import { SelectBox } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { HtmlEditor } from 'devextreme-react';
import { forEach } from 'lodash';

let key = 1;

export default function MasterAssayCalculator() {
    //todo remove:
    const [agilentData, setAgilentData] =
        useState<AgilentRawDataFile>();

    const [assayCalculator, setAssayCalculator] =
        useState<AssayCalculator>();

    const [assayCalculatorResults, setAssayCalculatorResults] =
        useState<AssayCalculator>();

    const [calculatorStandards, setCalculatorStandards] =
        useState<CalculatorStandard[]>();

    const [components, setComponents] =
        useState<CalculatorStandardComponent[]>();

    const [rawDataFileMissing, setRawDataFileMissing] =
        useState<boolean>();

    const [calculatorComponentsDialogVisible, setCalculatorComponentsDialogVisible] =
        useState<boolean>();

    const [calculatorStandardsDialogVisible, setCalculatorStandardsDialogVisible] =
        useState<boolean>()

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    const [agilentRawDataFileComponentVisible, setAgilentRawDataFileComponentVisible] =
        useState<boolean>()

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        if (assayCalculator && assayCalculator.calculatorId)
            getCalculatorStandards(assayCalculator.calculatorId);
    }, [assayCalculator]);

    useEffect(() => {
        if (assayCalculator && assayCalculator.calculatorId)
            getCalculatorComponents(assayCalculator.calculatorId);
    }, [calculatorStandards]);

    const parts = window.location.href.split('/');
    const batchId = parts[parts.length - 1];

    key++;

    // const lotReferenceTitle = assayCalculator && assayCalculator.catalogNumber && assayCalculator.batchName ?
    //   `${assayCalculator.catalogNumber} - ${assayCalculator.batchName}` : ""; 

    const catalogNumber = assayCalculator && assayCalculator.catalogNumber ? assayCalculator.catalogNumber : undefined;
    const batchName = assayCalculator && assayCalculator.batchName ? assayCalculator.batchName : undefined;

    let showRefStandard1Column = false;
    let showRefStandard2Column = false;
    let showRefStandard3Column = false;
    let refStandard1ColumnHeader = "";
    let refStandard2ColumnHeader = "";
    let refStandard3ColumnHeader = "";

    if (calculatorStandards && calculatorStandards.length > 0) {
        refStandard1ColumnHeader = `${calculatorStandards[0].catalogNumber}\n${calculatorStandards[0].lotNumber}\nConcentration`;
        showRefStandard1Column = true;
    }

    if (calculatorStandards && calculatorStandards.length > 1) {
        refStandard2ColumnHeader = `${calculatorStandards[1].catalogNumber}\n${calculatorStandards[1].lotNumber}\nConcentration`;
        showRefStandard2Column = true;
    }

    if (calculatorStandards && calculatorStandards.length > 2) {
        refStandard3ColumnHeader = `${calculatorStandards[2].catalogNumber}\n${calculatorStandards[2].lotNumber}\nConcentration`;
        showRefStandard3Column = true;
    }


    return (

        <div className="pw-form-container">
            <div className="pw-container">
                <div className="lq-title-bar">
                    <div className="lq-main-title">Master Assay Calculator</div>

                    <div className="title-bar-spacer" />
                    <div className="save-toolbar">
                        <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                            hint="go back" height={'2.6em'}
                            onClick={goBack} />
                    </div>
                </div>

                {/*
                <div className="pw-comp-row">
                    <div className="pw-form-unit lq-header-3">{catalogNumber} - {batchName}</div>
                </div>
                */}

                <div className="pw-comp-row">
                    <div className="pw-form-unit lq-header-3">MS Samples</div>
                </div>

                <div className="pw-comp-row">
                    <div className="pw-form-unit">
                        <div className="pw-form-unit-label">Catalog Number</div>
                        <div className="pw-readonly-label">{catalogNumber}</div>
                    </div>

                    <div className="pw-form-unit">
                        <div className="pw-form-unit-label">Batch Name</div>
                        <div className="pw-readonly-label">{batchName}</div>
                    </div>
                </div>

                {calculatorStandards && calculatorStandards.length > 0 && calculatorStandards.map((standard) =>
                    <div key={standard.calculatorStandardId}>
                        <div className="pw-comp-row">
                            <div className="pw-form-unit lq-header-3">{standard.catalogNumber} - {standard.lotNumber}</div>
                        </div>

                        <div className="pw-comp-row" key={standard.calculatorStandardId.toString()}>
                            <div className="pw-form-unit pw-comp-20">
                                <div className="pw-form-unit-label">Standards Manufacturer</div>
                                <div className="pw-readonly-label">{standard.standardManufacturer &&
                                    standard.standardManufacturer.description ?
                                    standard.standardManufacturer.description : 'NA'}</div>
                            </div>

                            <div className="pw-form-unit">
                                <div className="pw-form-unit-label">Standard Catalog#</div>
                                <div className="pw-readonly-label">{standard.catalogNumber ?
                                    standard.catalogNumber : 'NA'}</div>
                            </div>

                            <div className="pw-form-unit">
                                <div className="pw-form-unit-label">Standard Lot#</div>
                                <div className="pw-readonly-label">{standard.lotNumber ?
                                    standard.lotNumber : 'NA'}</div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="pw-comp-row pw-form-unit">
                    <Button id="loadRawDataFileButton" text="Upload Data File" icon="upload" type="success"
                        hint="load raw data"
                        height='2.6em'
                        onClick={loadRawDataFile} />
                    <div className="pw-margin-left-1">{rawDataFileMissing ? 'No raw data file uploaded' : agilentData && agilentData.fileName ? agilentData.fileName : ''}</div>
                </div>

                <div className="pw-form-unit pw-margin-bottom-1">
                    <DataGrid
                        width="100%"
                        height="18rem"
                        keyExpr="componentId"
                        dataSource={components ? components : []}
                        rowAlternationEnabled={true}
                        wordWrapEnabled={true}
                        showRowLines={true}
                        showBorders={true} >

                        <Selection mode='single' />
                        <Paging enabled={false} />

                        <Column width='2rem' cssClass="table-vertical-align"
                            cellRender={DataTemplates.EditMarkerCellRender} />

                        <Column dataField='componentName' dataType="string"
                            allowEditing={false}
                            width='20rem' cssClass="table-vertical-align" />

                        <Column dataField='lotNumber' dataType="string"
                            allowEditing={false}
                            width='10rem' cssClass="table-vertical-align" />

                        <Column dataField='concentration' dataType="number"
                            caption="MS Sample Concentration"
                            width='10rem' cssClass="table-vertical-align" />

                        {showRefStandard1Column &&
                            <Column dataField='refStandard1Concentration' dataType="number"
                                caption={refStandard1ColumnHeader}
                                width='10rem' cssClass="table-vertical-align" />
                        }

                        {showRefStandard2Column &&
                            <Column dataField='refStandard2Concentration' dataType="number"
                                caption={refStandard2ColumnHeader}
                                width='10rem' cssClass="table-vertical-align" />
                        }

                        {showRefStandard3Column &&
                            <Column dataField='refStandard3Concentration' dataType="number"
                                caption={refStandard3ColumnHeader}
                                width='10rem' cssClass="table-vertical-align" />
                        }

                        <Column />

                        <Toolbar>
                            <ToolbarItem location='before'>
                                <div className="pw-datagrid-toolbar-template">
                                    <div className="pw-datagrid-toobar-title">Components</div>
                                </div>
                            </ToolbarItem>
                            <ToolbarItem>
                                <Button id="editStandardsButton" text="Edit Standards" icon="edit" type="success"
                                    hint="edit standards"
                                    height='2.6em'
                                    onClick={onEditStandardsClick} />
                            </ToolbarItem>
                            <ToolbarItem>
                                <Button id="editComponentsButton" text="Edit Components" icon="edit" type="success"
                                    hint="add standard"
                                    height='2.6em'
                                    onClick={onEditComponentsClick} />
                            </ToolbarItem>
                        </Toolbar>

                        <Editing mode="cell"
                            useIcons={true}
                            allowAdding={false}
                            allowUpdating={true}
                            allowDeleting={false} />
                    </DataGrid>
                </div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-form-unit">
                    <Button id="runMasterAssayCalculatorButton" text="Run Calculator" icon="formula" type="success"
                        hint="run master assay calculator"
                        height='2.6em'
                        onClick={onRunMasterAssayCalculatorClick} />
                </div>
            </div>

            <div id="NoteViewerContainer" className="pw-form-section">
                <HtmlEditor height={assayCalculatorResults && assayCalculatorResults.assayCalculatorHtmlString
                    ? "100%" : "20rem"} readOnly={true}
                    value={assayCalculatorResults && assayCalculatorResults.assayCalculatorHtmlString ?
                        assayCalculatorResults.assayCalculatorHtmlString : undefined} />
            </div>

            <DmaFooter />

            {calculatorStandardsDialogVisible &&
                <DialogPopup visible={calculatorStandardsDialogVisible}
                    onHiding={hideCalculatorStandardsDialog}
                    title="Calculator Standards"
                    fullScreen={true}>
                    <CalculatorStandards calculatorId={assayCalculator && assayCalculator.calculatorId ?
                        assayCalculator.calculatorId : undefined} batchId={batchId}
                        catalogNumber={catalogNumber}
                        batchName={batchName}
                        onClose={hideCalculatorStandardsDialog}
                        key={`CS${key}`} />
                </DialogPopup>
            }

            {calculatorComponentsDialogVisible &&
                <DialogPopup visible={calculatorComponentsDialogVisible}
                    onHiding={hideCalculatorComponentsDialog}
                    title="Calculator Components"
                    fullScreen={true}>
                    <CalculatorComponents calculatorId={assayCalculator && assayCalculator.calculatorId ?
                        assayCalculator.calculatorId : undefined}
                        catalogNumber={catalogNumber}
                        batchName={batchName}
                        onClose={hideCalculatorComponentsDialog}
                        key={`CC${key}`} />
                </DialogPopup>
            }

            {agilentRawDataFileComponentVisible &&
                <DialogPopup visible={agilentRawDataFileComponentVisible}
                    onHiding={hideAgilentRawDataFileComponent}
                    title="Agilent Raw Data"
                    fullScreen={true}>
                    <AgilentRawDataFileComponent
                        batchId={batchId} onClose={hideAgilentRawDataFileComponent}
                        catalogNumber={catalogNumber}
                        batchName={batchName}
                        key={`TLE${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function onEditStandardsClick() {
        setCalculatorStandardsDialogVisible(true);
    }

    function onEditComponentsClick() {
        setCalculatorComponentsDialogVisible(true);
    }

    function loadRawDataFile() {
        setAgilentRawDataFileComponentVisible(true);
    }

    async function onRunMasterAssayCalculatorClick() {

        /*
        let assayRawData: AssayRawData = {
            groups: [
                {
                    name: "E",
                    samples: [
                        { sampleName: "E1", peakArea: 1768.69 },
                        { sampleName: "E2", peakArea: 1695.42 }
                    ]
                }, {
                    name: "M",
                    samples: [
                        { sampleName: "M1", peakArea: 1751.59 },
                        { sampleName: "M2", peakArea: 1749.44 }
                    ]
                }, {
                    name: "L",
                    samples: [
                        { sampleName: "L1", peakArea: 1750.19 },
                        { sampleName: "L2", peakArea: 1730.33 }
                    ]
                }, {
                    name: "R",
                    samples: [
                        { sampleName: "R1", peakArea: 1707.41 },
                        { sampleName: "R2", peakArea: 1725.33 }
                    ]
                }
            ]
        }
        */
        /*
        let calculator: AssayCalculator = {
            assayRawData: assayRawData,
            uspStandardValues: [1652.00, 1658.39, 1696.49, 1690.53, 1646.27, 1691.79],
            uspConcentration: uspValue,
            epConcentration: epValue,
            bpConcentration: bpValue
        }
        */

       if(batchId && assayCalculator && assayCalculator.calculatorId)
           await runMasterAssayCalculator(assayCalculator.calculatorId)
            .then((data) => {
                console.log("Running Master Assay Calculator RESULTS:");
                console.log(data);

            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Running Master Assay Calculator");
            })
    }

    function hideAgilentRawDataFileComponent() {
        setAgilentRawDataFileComponentVisible(false);
    }

    async function getAssayCalculator() {
        await CrudFunctions.getData(`calculator/assaycalculator/${batchId}`)
            .then((data) => {
                console.log("getAssayCalculator");
                console.log(data);

                setAssayCalculator(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Current Agilent Raw Data");
            });
    }

    async function getCalculatorStandards(calculatorId: string) {
        await CrudFunctions.getData(`calculator/calculatorstandards/${calculatorId}`)
            .then((data) => {
                setCalculatorStandards(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Current Agilent Raw Data");
            })
    }

    async function getCalculatorComponents(calculatorId: string) {
        await CrudFunctions.getData(`calculator/calculatorstandardcomponents/${calculatorId}`)
            .then((data) => {
                setComponents(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Components");
            })
    }

    async function getAgilentData() {
        await CrudFunctions.getData(`calculator/agilentrawdata/${batchId}`)
            .then((data) => {
                console.log("agilent raw data");
                console.log(data);

                if (data.MessageCode && data.MessageCode === 1)
                    setRawDataFileMissing(true);
                else {
                    setRawDataFileMissing(false);
                    setAgilentData(data);
                }
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Current Agilent Raw Data");
            })
    }

    async function runMasterAssayCalculator(calculatorId: string) {
        await CrudFunctions.getData(`calculator/runmasterassaycalculator/${batchId}/${calculatorId}`)
            .then((data) => {
                console.log("master assay calc results");
                console.log(data);

                setAssayCalculatorResults(data);

            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Current Agilent Raw Data");
            })
    }

    async function getAllData() {
        getAssayCalculator()
    }

    /*
    async function getAllCalculatorChildData(calculatorId: string) {
        await Promise.all([
            getCalculatorStandards(calculatorId),
            getCalculatorComponents(calculatorId)
        ]);
    }
    */

    //navigation

    function goBack() {
        history.back();
    }

    //show/hide

    function hideCalculatorStandardsDialog() {
        setCalculatorStandardsDialogVisible(false);
    }

    function hideCalculatorComponentsDialog() {
        setCalculatorComponentsDialogVisible(false);
    }

    //other

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}




{/*

                <div className="assay-calculator-sample-data-container">

                    {assayCalculator && assayCalculator.assayRawData &&
                        assayCalculator.assayRawData.groups ?
                        this.state.assayCalculator.assayRawData.groups.map((g) =>
                            <div className="assay-calculator-sample-group" key={g.name}>
                                <div>
                                    <div>{g.name}</div>

                                    <div>
                                        <DataGrid
                                            dataSource={g && g.samples ?
                                                g.samples : []}
                                            showBorders={false}>

                                            <Column dataField={'sampleName'} width={'50%'} />
                                            <Column dataField={'peakArea'} width={'50%'} />

                                        </DataGrid>
                                    </div>

                                </div>
                                <div>
                                    {g.analysis ? <div className="sample-assay-details">
                                        <div className="sample-assay-details">
                                            <div className="calculation-value-label">
                                                <div>RSD:</div>
                                                <div>Mean(x):</div>
                                                <div>σ:</div>
                                                <div>N:</div>
                                                <div>Df:</div>
                                            </div>
                                            <div className="calculation-value">
                                                <div>{g.analysis.rsd ? g.analysis.rsd : ''}</div>
                                                <div>{g.analysis.meanX ? g.analysis.meanX : ''}</div>
                                                <div>{g.analysis.sigma ? g.analysis.sigma : ''}</div>
                                                <div>{g.analysis.n ? g.analysis.n : ''}</div>
                                                <div>{g.analysis.df ? g.analysis.df : ''}</div>
                                            </div>

                                        </div>
                                        {g.analysis.k ?
                                            <div className="sample-assay-details">
                                                <div className="calculation-value-label">
                                                    <div>U-char:</div>
                                                    <div>U-comb:</div>
                                                    <div>df-eff:</div>
                                                    <div>uExpandedUncertainty:</div>
                                                    <div>y:</div>
                                                    <div>k:</div>
                                                </div>

                                                <div className="calculation-value">
                                                    <div>{g.analysis.wwPercent ? g.analysis.wwPercent : ''}</div>
                                                    <div>{g.analysis.wwPercent2 ? g.analysis.wwPercent2 : ''}</div>
                                                    <div>{g.analysis.dfEff ? g.analysis.dfEff : ''}</div>
                                                    <div>{g.analysis.uExpandedUncertainty ? g.analysis.uExpandedUncertainty : ''}</div>
                                                    <div>{g.analysis.y ? g.analysis.y : ''}</div>
                                                    <div>{g.analysis.k ? g.analysis.k : ''}</div>
                                                </div>
                                            </div> : ''}

                                    </div> : 'No analysis data'}
                                </div>
                            </div>
                        ) : <div>No data</div>}

                </div>

                <div>
                    <div className="bs-centered-title2">SUMMARY</div>

                    <div>
                        <DataGrid
                            dataSource={assayCalculator && assayCalculator.anovaCalculation &&
                                assayCalculator.anovaCalculation.summaries ?
                                assayCalculator.anovaCalculation.summaries : []}
                            showBorders={false}>

                            <Column dataField={'groupName'} width={'50%'} />
                            <Column dataField={'count'} width={'50%'} />
                            <Column dataField={'sum'} width={'50%'} />
                            <Column dataField={'average'} width={'50%'} />
                            <Column dataField={'variance'} width={'50%'} />
                        </DataGrid>
                    </div>

                </div>

                <div>
                    <div className="bs-centered-title2">ANOVA</div>

                    <div>
                        <table className="assay-calculator-anova-table">
                            <thead>
                                <tr>
                                    <th className="">Source of Variation</th>
                                    <th className="">SS</th>
                                    <th className="">df</th>
                                    <th className="">MS</th>
                                    <th className="">F</th>
                                    <th className="">P-value</th>
                                    <th className="">F crit</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Between Groups</td>

                                    <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.anovaCalculation &&
                                        this.state.assayCalculator.anovaCalculation.ssBetweenGroups ?
                                        this.state.assayCalculator.anovaCalculation.ssBetweenGroups : ''}</td>

                                    <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.anovaCalculation &&
                                        this.state.assayCalculator.anovaCalculation.dfBetweenGroups ?
                                        this.state.assayCalculator.anovaCalculation.dfBetweenGroups : ''}</td>

                                    <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.anovaCalculation &&
                                        this.state.assayCalculator.anovaCalculation.msBetweenGroups ?
                                        this.state.assayCalculator.anovaCalculation.msBetweenGroups : ''}</td>

                                    <td>{this.state.assayCalculator && this.state.assayCalculator.anovaCalculation &&
                                        this.state.assayCalculator.anovaCalculation.f ?
                                        this.state.assayCalculator.anovaCalculation.f : ''}</td>

                                    <td>{this.state.assayCalculator && this.state.assayCalculator.anovaCalculation &&
                                        this.state.assayCalculator.anovaCalculation.pValue ?
                                        this.state.assayCalculator.anovaCalculation.pValue : ''}</td>

                                    <td>{this.state.assayCalculator && this.state.assayCalculator.anovaCalculation &&
                                        this.state.assayCalculator.anovaCalculation.fCrit ?
                                        this.state.assayCalculator.anovaCalculation.fCrit : ''}</td>
                                </tr>
                                <tr>
                                    <td>Within Groups</td>
                                    <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.anovaCalculation &&
                                        this.state.assayCalculator.anovaCalculation.ssWithinGroups ?
                                        this.state.assayCalculator.anovaCalculation.ssWithinGroups : ''}</td>

                                    <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.anovaCalculation &&
                                        this.state.assayCalculator.anovaCalculation.dfWithinGroups ?
                                        this.state.assayCalculator.anovaCalculation.dfWithinGroups : ''}</td>

                                    <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.anovaCalculation &&
                                        this.state.assayCalculator.anovaCalculation.msWithinGroups ?
                                        this.state.assayCalculator.anovaCalculation.msWithinGroups : ''}</td>
                                    <td />
                                    <td />
                                    <td />
                                </tr>

                                <tr>
                                    <td>Total</td>

                                    <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.anovaCalculation &&
                                        this.state.assayCalculator.anovaCalculation.ssTotal ?
                                        this.state.assayCalculator.anovaCalculation.ssTotal : ''}</td>

                                    <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.anovaCalculation &&
                                        this.state.assayCalculator.anovaCalculation.dfTotal ?
                                        this.state.assayCalculator.anovaCalculation.dfTotal : ''}</td>
                                    <td />
                                    <td />
                                    <td />
                                    <td />
                                </tr>
                            </tbody>
                        </table>

                        <div className="bs-centered-title2">HOMOGENEITY</div>

                        <div>
                            <table className="assay-calculator-anova-table">

                                <tbody>
                                    <tr>
                                        <td></td>
                                        <td>Mean</td>
                                        <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.homogeneityCalculation &&
                                            this.state.assayCalculator.homogeneityCalculation.mean ?
                                            this.state.assayCalculator.homogeneityCalculation.mean : ''}</td>
                                        <td />
                                        <td>Relative</td>
                                        <td />
                                    </tr>

                                    <tr>
                                        <td></td>
                                        <td>√MSw =</td>
                                        <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.homogeneityCalculation &&
                                            this.state.assayCalculator.homogeneityCalculation.anovaWithinGroupsSqrt ?
                                            this.state.assayCalculator.homogeneityCalculation.anovaWithinGroupsSqrt : ''}</td>
                                        <td> = repeatability </td>
                                        <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.homogeneityCalculation &&
                                            this.state.assayCalculator.homogeneityCalculation.anovaWithinGroupsSqrtPercent ?
                                            this.state.assayCalculator.homogeneityCalculation.anovaWithinGroupsSqrtPercent : ''}</td>
                                        <td>%</td>
                                    </tr>

                                    <tr>
                                        <td>sbb</td>
                                        <td>√(MSb -MSw)/3 =</td>
                                        <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.homogeneityCalculation &&
                                            this.state.assayCalculator.homogeneityCalculation.sbb ?
                                            this.state.assayCalculator.homogeneityCalculation.sbb : ''}</td>
                                        <td> = bb standard uncertainty w/method variation</td>
                                        <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.homogeneityCalculation &&
                                            this.state.assayCalculator.homogeneityCalculation.sbbPercent ?
                                            this.state.assayCalculator.homogeneityCalculation.sbbPercent : ''}</td>
                                        <td>%</td>
                                    </tr>

                                    <tr>
                                        <td>u*bb</td>
                                        <td>(√MSw/n)(4√2/dfMSw)/k = 2</td>
                                        <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.homogeneityCalculation &&
                                            this.state.assayCalculator.homogeneityCalculation.ubb ?
                                            this.state.assayCalculator.homogeneityCalculation.ubb : ''}</td>
                                        <td> = bb standard uncertainty wo/method variation</td>
                                        <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.homogeneityCalculation &&
                                            this.state.assayCalculator.homogeneityCalculation.ubbPercent ?
                                            this.state.assayCalculator.homogeneityCalculation.ubbPercent : ''}</td>
                                        <td>%</td>
                                    </tr>

                                    <tr>
                                        <td />
                                        <td>k = 2</td>
                                        <td />
                                        <td />
                                        <td />
                                        <td />
                                    </tr>

                                    <tr>
                                        <td />
                                        <td />
                                        <td />
                                        <td />
                                        <td className="assay-calculator-anova-cell">{this.state.assayCalculator && this.state.assayCalculator.homogeneityCalculation &&
                                            this.state.assayCalculator.homogeneityCalculation.result ?
                                            this.state.assayCalculator.homogeneityCalculation.result : ''}</td>
                                        <td>%</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
                */}

